<template>
  <v-layout>
    <v-flex xs12>
      <v-btn
        color="info"
        @click="$emit('reset')"
      >
        Reset
      </v-btn>

      <v-btn
        color="success"
        @click="$emit('submit')"
      >
        Submit
      </v-btn>
    </v-flex>
  </v-layout>

</template>

<script>
  export default {
    name: "resetSubmit",
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/GeneralSettings/StylesSettings/styleSettingsFormComponents/ResetSubmit.vue